import { GridLegacy as Grid } from '@mui/material';
import styled from 'styled-components';

export const StyledHeader = styled(Grid)`
  margin-bottom: 12px;
  min-height: 48px;
`;
